import React from "react";
import { Form, DatePicker, Spin } from "antd";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";

import { DATE_FORMAT_FRONTEND, DATE_FORMAT_QUERY } from "../../../constants";
import PrimaryButton from "../../Buttons/PrimaryButton";
import TextButton from "../../Buttons/TextButton";
import { getTranslation } from "../../../utils/helper";

const BulkUpdateDeliveryDateForm = ({ form, isFetching, handleSubmit, handleCancel }) => {
  const user = useSelector(state => state.auth.user);
  const setting = user.company;

  const handleOnFinish = async values => {
    const params = setParams(values);
    await handleSubmit(params);
  };

  const setParams = values => {
    const params = { ...values };
    params.deliveryDate = values.deliveryDate ? values.deliveryDate.format(DATE_FORMAT_QUERY) : null;
    return params;
  };

  return (
    <Spin spinning={isFetching}>
      <div className="GroupForm">
        <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleOnFinish}>
          <div className="FormHeader">
            <div className="left">{getTranslation(setting, "Orders", "Bulk Update Date")}</div>
          </div>
          <div className="FormContent">
            <Form.Item
              label={getTranslation(setting, "Orders", "Date")}
              name="deliveryDate"
              rules={[{ required: true, message: "Required" }]}>
              <DatePicker
                size="large"
                style={{ width: "100%" }}
                format={DATE_FORMAT_FRONTEND}
                placeholder={getTranslation(setting, "Orders", "Date")}
              />
            </Form.Item>
          </div>
          <div className="FormFooter">
            <div className="Left"></div>
            <div className="Right">
              <TextButton label={getTranslation(setting, "Common", "Cancel")} onClick={handleCancel} />
              <PrimaryButton
                label={getTranslation(setting, "Common", "Update")}
                className="NewButton"
                htmlType="submit"
                icon={<ReactSVG className="icon" src="/icons/submit.svg" />}
              />
            </div>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default BulkUpdateDeliveryDateForm;
